import type { FaireProductEntity } from "../../entity_types/product";

export const p_3mf3f973m7: FaireProductEntity = {
  token: "p_3mf3f973m7",
  type: "product",
  name: "Alden Cotton Sweater (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/b15d524a8b76002993c9242674a6c4b2eebc629437e68571beb5a0e81587438f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/878f85f89a2087c6b267ea4aef4ff438ab8cf7e9889d7f46fb9de473b0fa3cfa.jpeg",
    "https://cdn.faire.com/fastly/23b32b635b7f44fb0d26f37ffd9f37cf987d5d3b5c2887df3ca51f2e2c7d74fe.jpeg",
  ],
  priceDollars: 220,
  description:
    'Why we made this?\n\nMeet the Alden: a cotton slub knit sweater defined by its artisanal texture and effortless ease. It features a structural ribbed neckline, soft dolman cap sleeves, and a relaxed, boxy fit. A favorite companion for transitional days—breathable enough for the noon sun, yet cozy enough for the dusk chill.\n\nContents: \n\n100% Cotton\n\n\nMade in South Korea\n\n\n\nCare Instructions:\n\nHand wash in cold water\n\nTowel dry & lay flat to dry\n\n\n\nApproximate Measurements: \n\nXS/S: Length 20", Chest 20 1/4"\n\nM/L: Length: 20 1/2", Chest: 21 3/4" \n\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S \n\n\n\nMSRP: $115 USD\n',
  tags: [],
  msrpDollars: 440,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:49.427Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
